/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { services } from "../../services";
let networkId = 1;
async function fetchNetworkId() {
  networkId = await services.getNetworkId();
}
fetchNetworkId();

function getContractAddresses() {
  networkId = 97;
  if (networkId === "0x61" || +networkId === 97) {
    return {
      token: "0x341218Eb704b45e72FFB73724E33a91F66f799dF",
      identityVerification: "0x5E15e475b7b1db1267aa1269E5Da5C5A97705fDA",
      complianceRegistry: "0x585C3cba6A529E83bb1108590C7023c810934946",
      resellPool: "0x3e7278774cfC60b33dB8cac1c0589b0164fa5231",
      propertyAssetImplimentation: "0xcFce20C472EC5DdB435E6dAc421D715D33ba3E83",
      propertyFactory: "0x198bc717410CcD92061cF5f4278Bedb15099C8dF",
      tokenRegistry: "0x77b89b12806444024a092dbC1129adaF8C55448A",
      rentalPool: "0x51a3571d587923F747Bf1Ebb6Bf5B83B817906C1",
    };
  } else if (+networkId === 56 || networkId === "0x38")
    return {
      token: "0x341218Eb704b45e72FFB73724E33a91F66f799dF",
      identityVerification: "0x5E15e475b7b1db1267aa1269E5Da5C5A97705fDA",
      complianceRegistry: "0x585C3cba6A529E83bb1108590C7023c810934946",
      resellPool: "0x3e7278774cfC60b33dB8cac1c0589b0164fa5231",
      propertyAssetImplimentation: "0xcFce20C472EC5DdB435E6dAc421D715D33ba3E83",
      propertyFactory: "0x198bc717410CcD92061cF5f4278Bedb15099C8dF",
      tokenRegistry: "0x77b89b12806444024a092dbC1129adaF8C55448A",
      rentalPool: "0x51a3571d587923F747Bf1Ebb6Bf5B83B817906C1",
    };
  else
    return {
      token: "0x341218Eb704b45e72FFB73724E33a91F66f799dF",
      identityVerification: "0x5E15e475b7b1db1267aa1269E5Da5C5A97705fDA",
      complianceRegistry: "0x585C3cba6A529E83bb1108590C7023c810934946",
      resellPool: "0x3e7278774cfC60b33dB8cac1c0589b0164fa5231",
      propertyAssetImplimentation: "0xcFce20C472EC5DdB435E6dAc421D715D33ba3E83",
      propertyFactory: "0x198bc717410CcD92061cF5f4278Bedb15099C8dF",
      tokenRegistry: " 0x77b89b12806444024a092dbC1129adaF8C55448A",
      rentalPool: "0x51a3571d587923F747Bf1Ebb6Bf5B83B817906C1",
    };
}
export default getContractAddresses;
